var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature33(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_941_852)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_941_852",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H30V30H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_941_852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2238 2.19C17.2238 3.39948 16.2432 4.38 15.0338 4.38C13.8243 4.38 12.8438 3.39948 12.8438 2.19C12.8438 0.98052 13.8243 0 15.0338 0C16.2432 0 17.2238 0.98052 17.2238 2.19Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.03 4.37891H11.28C7.98852 4.37891 5.19624 6.51635 4.21542 9.47891H4.08C1.8267 9.47891 0 11.3056 0 13.5589C0 15.8122 1.8267 17.6389 4.08 17.6389H4.17684C5.12124 20.6636 7.94424 22.8589 11.28 22.8589H18.78C22.1158 22.8589 24.9388 20.6636 25.8832 17.6389H25.92C28.1733 17.6389 30 15.8122 30 13.5589C30 11.3056 28.1733 9.47891 25.92 9.47891H25.8446C24.8638 6.51635 22.0715 4.37891 18.78 4.37891H15.03ZM22.3012 13.0789C22.3012 14.6171 21.0541 15.8642 19.5158 15.8642C17.9776 15.8642 16.7306 14.6171 16.7306 13.0789C16.7306 11.5406 17.9776 10.2936 19.5158 10.2936C21.0541 10.2936 22.3012 11.5406 22.3012 13.0789ZM10.4653 15.8642C12.0035 15.8642 13.2506 14.6171 13.2506 13.0789C13.2506 11.5406 12.0035 10.2936 10.4653 10.2936C8.92704 10.2936 7.68 11.5406 7.68 13.0789C7.68 14.6171 8.92704 15.8642 10.4653 15.8642Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39844 30.0011C7.19592 26.5093 10.8358 24.1211 15.0335 24.1211C19.2313 24.1211 22.8712 26.5093 24.6686 30.0011H5.39844Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_941_852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature33);
export default __webpack_public_path__ + "static/media/feature-3-3.4c599fee37f68d724b939c7992061437.svg";
export { ForwardRef as ReactComponent };